// extracted by mini-css-extract-plugin
module.exports = {"inline-button":"inline-text-button__inline-button___1GizL"};